import { ButtonSize, FAIcon } from '@nextgen-web-framework/all';
import styles from './ButtonLoader.module.scss';
import { type ButtonLoaderProps } from './types/propsType';

export const ButtonLoader = ({ size = ButtonSize.MEDIUM, className, isStepper = false }: ButtonLoaderProps) => (
  <div
    className={`
    ${!isStepper && styles['button-loader-min-width']}
    ${styles['button-loader-container']} ${
      size === ButtonSize.SMALL ? styles['button-loader-container-small'] : styles['button-loader-container-medium']
    }
    ${className}
    `}
  >
    <div className={styles['button-loader-container-icon-container']}>
      <FAIcon className={styles['button-loader-container-icon']} iconName="spinner-third" />
    </div>
  </div>
);

export type { ButtonLoaderProps };
